import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../utils/api';
import './admin.css';

export default function AdminLogin() {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await api.post('/admin/login', { username, password });
      localStorage.setItem('als_admin_token', res.data.token);
      localStorage.setItem('als_admin_role', res.data.role);
      localStorage.setItem('als_admin_user', JSON.stringify({
        username: res.data.username,
        displayName: res.data.displayName,
        role: res.data.role
      }));
      // Staff goes straight to scanner, admin to dashboard
      if (res.data.role === 'staff') {
        navigate('/admin/scan');
      } else {
        navigate('/admin/dashboard');
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Invalid credentials. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-login">
      <div className="admin-login-card">
        <div className="admin-login-logo">ALS</div>
        <p className="admin-login-sub">Staff & Admin Portal · Grand Opening 2026</p>
        {error && <div className="admin-login-error">{error}</div>}
        <form onSubmit={handleSubmit}>
          <div className="admin-field">
            <label className="admin-label">Username</label>
            <input
              className="admin-input" type="text"
              placeholder="Enter your username"
              value={username} onChange={e => setUsername(e.target.value)}
              autoFocus autoComplete="username"
            />
          </div>
          <div className="admin-field">
            <label className="admin-label">Password</label>
            <input
              className="admin-input" type="password"
              placeholder="Enter your password"
              value={password} onChange={e => setPassword(e.target.value)}
              autoComplete="current-password"
            />
          </div>
          <button className="admin-btn" style={{ width: '100%', padding: '14px', marginTop: 4 }} disabled={loading}>
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>
      </div>
    </div>
  );
}
